"use client";

import { motion } from "framer-motion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Premium\nPresentation",
  description: "A professionally prepared course profile using approved content and imagery.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_presentation.png?v=2"
}, {
  title: "Traveller-Ready Information",
  description: "Visitor access, facilities, caddies, buggy, dress code and booking details.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_info.png?v=2"
}, {
  title: "Greater Control",
  description: "Control how your course, rates, offers and booking routes are presented.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_greatercontrol.png?v=2"
}, {
  title: "Priority Support",
  description: "Faster updates and a direct TeeListClub contact for your course team.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_support.png?v=2"
}, {
  title: "Relevant\nVitality",
  description: "Opportunities across destination content, collections and travel guides.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_relevant.png?v=2"
}, {
  title: "Commercial Activation",
  description: "Selected campaigns built around seasons, markets, packages or destination priorities.",
  iconUrl: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landing_activiation.png?v=2"
}];
export default function PartnerBenefitsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.12
  });
  return <section id="partnerbenefitsgrid" ref={ref} aria-labelledby="partner-benefits-heading" className="w-full overflow-hidden bg-[#FFFDF7] !h-[500px] ![padding:40px_32px_48px_32px]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1480px] !h-[400px]">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: "easeOut"
      }} className="mx-auto mb-12 max-w-[780px] text-center md:mb-14">
          <p className="font-bold uppercase tracking-[0.19em] text-[#9A793A] !text-xs">
            Paid Partnership
          </p>

         <h2 id="partner-benefits-heading" className={["tlc-playfair-heading", "mt-3 p-0", "text-[44px] md:text-[50px]", "font-medium", "leading-[1.08]", "tracking-[-0.03em]", "text-[#073F31]"].join(" ")}>What a TeeListClub Partner receives.</h2>

          <p className="mx-auto mt-4 max-w-[700px] leading-[1.7] text-[#65746D] !text-base">
            A managed course presence designed to improve how your course is
            presented, maintained and connected with relevant golf travellers.
          </p>
        </motion.div>

        {/* This is the only card grid in the component */}
        <div className="grid grid-cols-1 gap-5 2xl:grid-cols-6 !h-[300px] ![margin:-40px_0px_-40px_0px] sm:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 22
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.07,
          ease: "easeOut"
        }} className="group relative flex min-h-0 flex-col items-center overflow-hidden rounded-[16px] border border-[#DED3BF] bg-[#F7F3E9] text-center shadow-[0_8px_24px_rgba(7,63,49,0.045)] transition-all duration-300 ![padding:0px_15px_0px_15px] !h-[230px] hover:-translate-y-[3px] hover:border-[#B79A5F]/75 hover:shadow-[0_15px_32px_rgba(7,63,49,0.09)]">
    <div aria-hidden="true" className="absolute inset-x-5 top-0 h-px bg-gradient-to-r from-transparent via-[#B79A5F]/60 to-transparent" />

    <div className="flex h-[118px] w-full shrink-0 items-center justify-center">
      <img src={benefit.iconUrl} alt="" aria-hidden="true" loading="lazy" decoding="async" className="block h-[118px] w-[118px] object-contain opacity-100 transition-transform duration-300 group-hover:scale-[1.04] !p-0" />
    </div>

    <h3 className="flex min-h-[48px] items-center justify-center text-[18px] font-semibold leading-[1.25] text-[#073F31] ![margin:-6px_0px_-6px_0px]">
  {benefit.title}
          </h3>
          <p className="mt-1 text-[12px] leading-[1.5] text-[#596B63]">
  {benefit.description}
          </p>
  </motion.article>)}
        </div>
      </div>
    </section>;
}